import type { LiveQuoteRequest, LiveQuoteResponse } from 'apiConnector/secondary-market/live/models';
import type { SecondaryWorkspaceType } from 'state/workspaces/model';

export type SecondaryMarketLiveQuoteActions =
  | SecondaryMarketLiveQuoteRequested
  | SecondaryMarketLiveQuoteReceived
  | SecondaryMarketLiveQuoteFailed
  | SecondaryMarketLiveQuoteRejected
  | SecondaryMarketLiveQuoteCleared
  | SecondaryMarketLiveQuoteDurationEnded
  | SecondaryMarketLiveQuoteExpired
  | SecondaryMarketLiveQuoteCancelRequested
  | SecondaryMarketLiveQuoteCancelReceived
  | SecondaryMarketLiveQuoteCancelFailed;

/////////////////////////////////////////////
export function secondaryMarketLiveQuoteRequested(
  tabId: string,
  workspaceType: SecondaryWorkspaceType,
  request: LiveQuoteRequest,
  isReprice: boolean = false,
) {
  return {
    type: 'SECONDARY_MARKET_LIVE_QUOTE_REQUESTED' as const,
    tabId,
    workspaceType,
    request,
    isReprice,
  };
}

export type SecondaryMarketLiveQuoteRequested = ReturnType<typeof secondaryMarketLiveQuoteRequested>;

/////////////////////////////////////////////
export function secondaryMarketLiveQuoteReceived(tabId: string, data: LiveQuoteResponse, timestamp: Date) {
  return {
    type: 'SECONDARY_MARKET_LIVE_QUOTE_RECEIVED' as const,
    tabId,
    data,
    timestamp,
  };
}

export type SecondaryMarketLiveQuoteReceived = ReturnType<typeof secondaryMarketLiveQuoteReceived>;

/////////////////////////////////////////////
export function secondaryMarketLiveQuoteDurationEnded(tabId: string, quoteId: string) {
  return {
    type: 'SECONDARY_MARKET_LIVE_QUOTE_DURATION_ENDED' as const,
    tabId,
    quoteId,
  };
}

export type SecondaryMarketLiveQuoteDurationEnded = ReturnType<typeof secondaryMarketLiveQuoteDurationEnded>;

/////////////////////////////////////////////
export function secondaryMarketLiveQuoteExpired(tabId: string, quoteId: string, productKey: string) {
  return {
    type: 'SECONDARY_MARKET_LIVE_QUOTE_EXPIRED' as const,
    tabId,
    quoteId,
    productKey,
  };
}

export type SecondaryMarketLiveQuoteExpired = ReturnType<typeof secondaryMarketLiveQuoteExpired>;

/////////////////////////////////////////////

export function secondaryMarketLiveQuoteRejected(tabId: string, productKey: string, error?: string) {
  return {
    type: 'SECONDARY_MARKET_LIVE_QUOTE_REJECTED' as const,
    tabId,
    error,
    productKey,
  };
}
export type SecondaryMarketLiveQuoteRejected = ReturnType<typeof secondaryMarketLiveQuoteRejected>;

/////////////////////////////////////////////

export function secondaryMarketLiveQuoteFailed(tabId: string, productKey: string, error?: string, timeout?: number) {
  return {
    type: 'SECONDARY_MARKET_LIVE_QUOTE_FAILED' as const,
    tabId,
    error,
    productKey,
    timeout,
  };
}
export type SecondaryMarketLiveQuoteFailed = ReturnType<typeof secondaryMarketLiveQuoteFailed>;

/////////////////////////////////////////////

export function secondaryMarketLiveQuoteCancelRequested(
  tabId: string,
  quoteId: string,
  productKey: string,
  shouldSendCancellation?: boolean,
) {
  return {
    type: 'SECONDARY_MARKET_LIVE_QUOTE_CANCEL_REQUESTED' as const,
    tabId,
    quoteId,
    productKey,
    shouldSendCancellation,
  };
}
export type SecondaryMarketLiveQuoteCancelRequested = ReturnType<typeof secondaryMarketLiveQuoteCancelRequested>;
/////////////////////////////////////////////

export function secondaryMarketLiveQuoteCancelReceived(quoteId: string) {
  return {
    type: 'SECONDARY_MARKET_LIVE_QUOTE_CANCEL_RECEIVED' as const,
    quoteId,
  };
}
export type SecondaryMarketLiveQuoteCancelReceived = ReturnType<typeof secondaryMarketLiveQuoteCancelReceived>;

/////////////////////////////////////////////
export function secondaryMarketLiveQuoteCancelFailed(quoteId: string, error?: string) {
  return {
    type: 'SECONDARY_MARKET_LIVE_QUOTE_CANCEL_FAILED' as const,
    quoteId,
    error,
  };
}
export type SecondaryMarketLiveQuoteCancelFailed = ReturnType<typeof secondaryMarketLiveQuoteCancelFailed>;

/////////////////////////////////////////////
export function secondaryMarketLiveQuoteCleared(tabId: string) {
  return {
    type: 'SECONDARY_MARKET_LIVE_QUOTE_CLEARED' as const,
    tabId,
  };
}
export type SecondaryMarketLiveQuoteCleared = ReturnType<typeof secondaryMarketLiveQuoteCleared>;
